(function () {
  const MOBICRED_FILENAME = 'wtw-payment-mobicred.png';
  const getCartPath = () => (window.routes && routes.cart_url) || '/cart';

  const getAssetUrlFromPaymentRow = (row) => {
    const logo = row.querySelector('img[src*="/assets/"]');
    if (!logo) return null;
    return logo.src.replace(/assets\/[^/?#]+.*/, `assets/${MOBICRED_FILENAME}`);
  };

  const addMobicredToTrustRows = () => {
    document.querySelectorAll('.wtw-trust-payment').forEach((row) => {
      if (row.querySelector('[data-wtw-mobicred-logo]')) return;
      const assetUrl = getAssetUrlFromPaymentRow(row);
      if (!assetUrl) return;

      const badge = document.createElement('span');
      badge.className = 'wtw-mobicred-pay-badge';
      badge.dataset.wtwMobicredLogo = 'true';

      const image = document.createElement('img');
      image.src = assetUrl;
      image.alt = 'Mobicred';
      image.width = 76;
      image.height = 20;
      image.loading = 'lazy';
      badge.appendChild(image);

      row.insertBefore(badge, row.querySelector('.wtw-secure') || null);
    });
  };

  const addMobicredInstallments = () => {
    const price = document.querySelector('.product [id^="price-"]');
    if (!price || document.getElementById('WTWMobicredInstallments')) return;

    const installments = document.createElement('p');
    installments.id = 'WTWMobicredInstallments';
    installments.className = 'wtw-mobicred-installments';
    installments.textContent = 'Or pay in installments with Mobicred';
    price.insertAdjacentElement('afterend', installments);
  };

  const getCartCount = async () => {
    try {
      const cart = await fetch(`${getCartPath()}.js`).then((response) => response.json());
      return cart.item_count || 0;
    } catch (error) {
      return 0;
    }
  };

  const escapeHTML = (value) =>
    String(value).replace(/[&<>"']/g, (character) => {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });

  const cleanMoneyText = (value) => String(value || '').replace(/\s*ZAR\b/g, '').trim();

  const cleanCurrencySuffixes = () => {
    if (!document.body) return;

    const nodes = [];
    const ignoredTags = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        const text = node.textContent || '';
        const parent = node.parentElement;
        if (!parent || ignoredTags.includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return /R\s*\d[\d\s.,]*\s*ZAR\b/.test(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.textContent = cleanMoneyText(node.textContent);
    });
  };

  const getFeaturedProductImage = () => {
    const metadataImage = document.querySelector(
      'meta[property="og:image:secure_url"], meta[property="og:image"], meta[name="twitter:image"]'
    );
    if (metadataImage?.content) {
      return {
        alt: document.querySelector('meta[property="og:title"]')?.content || '',
        src: metadataImage.content,
      };
    }

    const galleryImage = document.querySelector(
      'media-gallery .product__media-item:first-child img, .product__media-list .product__media-item:first-child img, media-gallery img, .product__media img'
    );
    return {
      alt: galleryImage?.alt || '',
      src: galleryImage?.currentSrc || galleryImage?.src || '',
    };
  };

  const getProductSummary = () => {
    const title =
      document.querySelector('.product__title h1')?.textContent?.trim() ||
      document.querySelector('.product__title')?.textContent?.trim() ||
      document.querySelector('h1')?.textContent?.trim() ||
      '';
    const priceContainer = document.querySelector('.product [id^="price-"]');
    const priceItems = Array.from(priceContainer?.querySelectorAll('.price-item') || []);
    const price =
      cleanMoneyText(priceItems.find((item) => !item.closest('s') && item.textContent.trim())?.textContent) ||
      cleanMoneyText(priceContainer?.textContent?.replace(/\s+/g, ' ')) ||
      '';
    const image = getFeaturedProductImage();

    return {
      imageAlt: image.alt || title,
      imageSrc: image.src,
      price,
      title,
    };
  };

  const refreshAllCheckoutCounts = async () => {
    const count = await getCartCount();
    document.querySelectorAll('.wtw-sticky-checkout__count').forEach((el) => {
      el.textContent = count;
    });
    document.querySelectorAll('.wtw-sticky-checkout__btn').forEach((btn) => {
      if (count < 1) btn.style.display = 'none';
      else btn.style.display = '';
    });
    const productBar = document.querySelector('[data-wtw-sticky-actions]');
    if (productBar && count > 0 && !productBar.querySelector('.wtw-sticky-checkout__btn')) {
      const buttonsWrap = productBar.querySelector('.wtw-product-sticky-actions__buttons');
      if (buttonsWrap) {
        const link = document.createElement('a');
        link.href = getCartPath();
        link.className = 'button button--secondary wtw-sticky-checkout__btn';
        link.innerHTML = `Checkout <span class="wtw-sticky-checkout__count">${count}</span>`;
        buttonsWrap.appendChild(link);
      }
    }
    const globalBar = document.querySelector('[data-wtw-global-sticky-checkout]');
    if (!globalBar && count > 0 && !document.querySelector('.product-form__submit') && !document.body.classList.contains('template-cart')) {
      createGlobalStickyCheckout();
    }
  };

  const createStickyActions = async () => {
    if (document.querySelector('[data-wtw-sticky-actions]')) return;

    const sourceButton = document.querySelector('.product-form__submit');
    const sourceForm = sourceButton?.closest('form');
    if (!sourceButton || !sourceForm) return;

    const cartCount = await getCartCount();
    if (document.querySelector('[data-wtw-sticky-actions]')) return;

    const productSummary = getProductSummary();
    const bar = document.createElement('div');
    bar.className = 'wtw-product-sticky-actions';
    bar.dataset.wtwStickyActions = 'true';
    bar.innerHTML = `
      <div class="wtw-product-sticky-actions__inner page-width">
        <div class="wtw-product-sticky-actions__summary">
          ${
            productSummary.imageSrc
              ? `<img src="${escapeHTML(productSummary.imageSrc)}" alt="${escapeHTML(productSummary.imageAlt)}" width="56" height="56" loading="lazy">`
              : ''
          }
          <div class="wtw-product-sticky-actions__copy">
            <p data-wtw-sticky-title></p>
            <span data-wtw-sticky-price></span>
          </div>
        </div>
        <div class="wtw-product-sticky-actions__buttons">
          <button type="button" class="button button--primary wtw-sticky-atc__btn" data-wtw-sticky-submit>
            <span></span>
          </button>
          ${
            cartCount > 0
              ? `<a href="${getCartPath()}" class="button button--secondary wtw-sticky-checkout__btn">Checkout <span class="wtw-sticky-checkout__count">${cartCount}</span></a>`
              : ''
          }
        </div>
      </div>
    `;
    document.body.appendChild(bar);

    const stickyButton = bar.querySelector('[data-wtw-sticky-submit]');
    const stickyText = stickyButton.querySelector('span');
    const stickyTitle = bar.querySelector('[data-wtw-sticky-title]');
    const stickyPrice = bar.querySelector('[data-wtw-sticky-price]');
    const syncButton = () => {
      const sourceText = sourceButton.querySelector('span')?.textContent?.trim();
      if (sourceText) stickyText.textContent = sourceText;
      stickyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
    };
    const syncSummary = () => {
      const summary = getProductSummary();
      if (summary.title) stickyTitle.textContent = summary.title;
      if (summary.price) stickyPrice.textContent = summary.price;
    };

    stickyButton.addEventListener('click', () => {
      syncButton();
      if (stickyButton.disabled) return;
      if (sourceForm.requestSubmit) {
        sourceForm.requestSubmit(sourceButton);
      } else {
        sourceButton.click();
      }
    });

    syncButton();
    syncSummary();
    new MutationObserver(syncButton).observe(sourceButton, { attributes: true, childList: true, subtree: true });
    const priceContainer = document.querySelector('.product [id^="price-"]');
    if (priceContainer) {
      new MutationObserver(syncSummary).observe(priceContainer, { childList: true, subtree: true });
    }

    const headerEl = document.querySelector('.header-wrapper') || document.querySelector('header');
    let headerThreshold = 0;
    if (headerEl) {
      let el = headerEl;
      while (el) { headerThreshold += el.offsetTop; el = el.offsetParent; }
      headerThreshold += headerEl.offsetHeight;
    }

    let visibilityPending = false;
    const updateStickyVisibility = () => {
      visibilityPending = false;
      const rect = sourceButton.getBoundingClientRect();
      const styles = window.getComputedStyle(sourceButton);
      const isRendered = rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
      const pastHeader = window.scrollY > headerThreshold;
      bar.classList.toggle('is-visible', pastHeader && (!isRendered || !isInViewport));
    };
    const requestVisibilityUpdate = () => {
      if (visibilityPending) return;
      visibilityPending = true;
      window.requestAnimationFrame(updateStickyVisibility);
    };

    updateStickyVisibility();
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(requestVisibilityUpdate, { rootMargin: '0px', threshold: [0, 1] }).observe(sourceButton);
    }
  };

  const createGlobalStickyCheckout = async () => {
    if (document.querySelector('.product-form__submit') || document.querySelector('[data-wtw-global-sticky-checkout]')) return;
    if (document.body.classList.contains('template-cart')) return;
    if (window.location.pathname.replace(/\/$/, '') === getCartPath().replace(/\/$/, '')) return;

    const cartCount = await getCartCount();
    if (cartCount < 1 || document.querySelector('[data-wtw-global-sticky-checkout]')) return;

    const bar = document.createElement('div');
    bar.className = 'wtw-global-sticky-checkout';
    bar.dataset.wtwGlobalStickyCheckout = 'true';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cart checkout');
    bar.innerHTML = `<a href="${getCartPath()}" class="button button--primary wtw-sticky-checkout__btn">Checkout <span class="wtw-sticky-checkout__count">${cartCount}</span></a>`;
    document.body.appendChild(bar);
  };

  const hideLegacyStickyATC = () => {
    if (!document.querySelector('.product-form__submit')) return;

    document.querySelectorAll('button, a').forEach((control) => {
      if (control.closest('[data-wtw-sticky-actions], [data-wtw-global-sticky-checkout]')) return;
      if (!/add\s+to\s+cart/i.test(control.textContent || '')) return;

      let candidate = control;
      while (candidate && candidate !== document.body) {
        const styles = window.getComputedStyle(candidate);
        const rect = candidate.getBoundingClientRect();
        const isBottomLayer =
          (styles.position === 'fixed' || styles.position === 'sticky') &&
          rect.width > window.innerWidth * 0.45 &&
          rect.bottom > window.innerHeight - 180;

        if (isBottomLayer) {
          candidate.classList.add('wtw-legacy-sticky-hidden');
          return;
        }

        candidate = candidate.parentElement;
      }
    });
  };

  const refreshWTWEnhancements = () => {
    addMobicredToTrustRows();
    cleanCurrencySuffixes();
    addMobicredInstallments();
    hideLegacyStickyATC();
    createStickyActions();
    createGlobalStickyCheckout();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshWTWEnhancements, { once: true });
  } else {
    refreshWTWEnhancements();
  }

  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
      window.requestAnimationFrame(() => {
        pending = false;
        addMobicredToTrustRows();
        cleanCurrencySuffixes();
        hideLegacyStickyATC();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('scroll', hideLegacyStickyATC, { passive: true });
  window.addEventListener('resize', hideLegacyStickyATC);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAllCheckoutCounts);
  }
  document.addEventListener('cart:refresh', refreshAllCheckoutCounts);

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const result = originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (/\/cart\/(add|change|update|clear)\.js/i.test(url)) {
      result.then(() => {
        setTimeout(refreshAllCheckoutCounts, 300);
      }).catch(() => {});
    }
    return result;
  };
})();
